<template>
  <v-main style="min-height: 70vh">
    <v-container class="responsive-template-content">
      <v-row dense>
        <PersonalInformationForm />
        <UpdatePasswordForm />
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import PersonalInformationForm from "@/components/Company/PersonalInformationForm.vue";
import UpdatePasswordForm from "@/components/Company/UpdatePasswordForm.vue";
import Vue from "vue";

export default Vue.extend({
  name: "CompanyPersonalInformation",
  components: { PersonalInformationForm, UpdatePasswordForm },
  data: function () {
    return {};
  },
});
</script>

<style scoped></style>
